import type { ExportEnd } from '~/components/workspaces/lib/export-pages';

const describeEnd = (end: ExportEnd) => {
  if (end.source === 'none') return 'None';
  if (end.source === 'design' && end.origin === null) return "the design's pages";
  return end.pages.map((page) => page.name).join(', ');
};

const EndRow = ({ label, end }: { label: string; end: ExportEnd }) => (
  <li className="text-xs text-neutral-700 dark:text-neutral-300">
    <span className="font-medium">{label}:</span> {describeEnd(end)}
    {end.source !== 'none' && end.origin !== null && (
      <span className="text-neutral-500 dark:text-neutral-400">
        {' '}
        (from {end.source} {end.origin})
      </span>
    )}
  </li>
);

/** Read-only: the pages an export prints around the document, in order. */
export const ExportPagesSummary = ({ start, end }: { start: ExportEnd; end: ExportEnd }) => (
  <div>
    <h3 className="text-sm font-medium font-body mt-0">Pages that print</h3>
    <ol className="mt-2 space-y-1 list-none pl-0">
      <EndRow label="Start" end={start} />
      <li className="text-xs text-neutral-700 dark:text-neutral-300">Your document</li>
      <EndRow label="End" end={end} />
    </ol>
  </div>
);
